import React from "react";

export const Loading = ({ layer = true }) => {
    return (
        <div className={`loading ${!layer ? "no-layer" : ""}`}>
            <svg className="loading-circle">
                <circle cx="50%" cy="50%" r="25"></circle>
            </svg>
        </div>
    );
};
